// strategy for deciding which Agency-Portal tabs are visible per ATS (pack)
// A pack name corresponds to an ATS (e.g. "jobylon", "recruitee", "smartrecruiters").
// The strategy returns an array of keys identifying the tabs to be rendered.

import type { PackName } from './constants';

export type AgencyPortalTab =
    | 'agencyInbox'
    | 'recruiterManagement'
    | 'masterContracts'
    | 'invoicing'
    | 'permissionsSettings'
    | 'analytics';

// Default (fallback) tab order – covers the full Agency-Portal feature set.
const defaultTabs: AgencyPortalTab[] = [
    'recruiterManagement',
    'agencyInbox',
    'masterContracts',
    'invoicing',
    'permissionsSettings',
    'analytics',
];

// Per-ATS overrides.  Omit tabs that should be hidden for that pack.
// Currently only Jobylon deviates.
const tabStrategies: Record<PackName, AgencyPortalTab[] | undefined> = {
    jobylon: [
        // 'recruiterManagement',
        'agencyInbox',
        'masterContracts',
        'invoicing',
        'permissionsSettings',
        'analytics',
    ],
    recruitee: undefined,          // uses default
    smartrecruiters: undefined,    // uses default
};

export const getAgencyPortalTabs = (pack?: PackName): AgencyPortalTab[] => {
    return tabStrategies[pack as PackName] ?? defaultTabs;
}; 